import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

export default function NoOrganization() {
  const { signOut } = useAuth();

  const handleSignOut = async () => {
    try {
      console.log('🔄 Tentando fazer logout...');
      await signOut();
      console.log('✅ Logout realizado com sucesso');
    } catch (error) {
      console.error('❌ Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-12 h-12 bg-warning/10 rounded-full flex items-center justify-center">
            <AlertTriangle className="h-6 w-6 text-warning" />
          </div>
          <CardTitle className="text-xl font-semibold">Organização não encontrada</CardTitle>
          <CardDescription className="text-center">
            Oops! Parece que seu e-mail não está relacionado a nenhuma organização. Entre em contato com o seu RH.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-muted-foreground">
            <p>Se você acredita que isso é um erro, entre em contato com:</p>
            <p className="font-medium mt-2">contato@lyrarh.com.br</p>
            <p>WhatsApp: (11) 97832-0011</p>
          </div>
          <Button onClick={handleSignOut} className="w-full" variant="outline">
            Sair e tentar novamente
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}